<template>
    <div id="div_header">
        <div id="div_left">
			Junpeng Wang
        </div>
        <div id="div_right">
            <nav>
                <ul>
                    <li><router-link to="/" exact>Home</router-link></li>
                    <li><router-link to="/publication" exact>Publication</router-link></li>
                    <li><router-link to="/service" exact>Service</router-link></li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style scoped>

#div_header:after { 
    content: " "; 
    display: block;
    clear: both;
    border-bottom: 1px solid #eeeeee;
} 
#div_left{
    width: 24%;
    float: left;
    font-size:28px;
    font-weight: bold;
    text-align: center;
    padding: 8px 0px 5px 0px;
}
#div_right{
    width: 74%;
    float: right;
}
ul{
    list-style-type: none;
    text-align: right;
    margin: 0;
    /* padding: 0 0 0 100px; */
}
li{
    display: inline-block;
    margin: 0 10px;
}
a{
    color: #aaa;
    text-decoration: none;
    padding: 6px 8px;
    border-radius: 10px;
}
nav{
    /* background: #444; */
    padding: 14px 0;
    /* margin-bottom: 40px; */
    margin-right: 20px;
}
.router-link-active{
    background: #eee;
    color: #444;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue